import EmailReader from "modules/backoffice/components/emailReader"

export default function BackofficeOutlookReader() {
  return <EmailReader basePath="/backoffice/outlookReader" i18nPrefix="backoffice.outlookReader" />
}
